import { render, staticRenderFns } from "./SamlDomainSwitcher.vue?vue&type=template&id=710b5dc8&scoped=true&"
import script from "./SamlDomainSwitcher.vue?vue&type=script&lang=js&"
export * from "./SamlDomainSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./SamlDomainSwitcher.vue?vue&type=style&index=0&id=710b5dc8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710b5dc8",
  null
  
)

export default component.exports